import { boolean, mixedObj, object, constraints } from "./helpers";
import { DeviceSettingOptions } from "./settingOptions";
import { Wireless } from "./types";

export const wireless = object<Wireless>({
  bluetooth: object({
    value: boolean("BLUETOOTH"),
    constraints: constraints()
  }),
  connection_indication: object({
    value: mixedObj(
      DeviceSettingOptions.connectionIndicationOpts,
      "CONNECTION_INDICATION"
    )
  }),
  bluetooth_streaming: object({
    value: mixedObj(
      DeviceSettingOptions.bluetoothStreamingOpts,
      "BLUETOOTH_STREAMING"
    )
  }),
  secure_bluetooth: object({
    value: boolean("SECURE_BLUETOOTH"),
    constraints: constraints()
  }),
  exclusive_connection: object({
    value: boolean("EXCLUSIVE_CONNECTION"),
    constraints: constraints()
  })
}).required();
